export const clampPageAfterRemoval = (page, totalCount, rowsPerPage) => {
    const lastPage = Math.max(Math.ceil((totalCount - 1) / rowsPerPage) - 1, 0);
    return Math.min(page, lastPage);
};
